import { useTranslation } from "react-i18next";
import { Accordion, AccordionDetails, AccordionGroup, AccordionSummary, Stack, Typography } from "~/common/mui";

export const HelpInformation = () => {
  const { t } = useTranslation();

  return (
    <Stack gap={2}>
      <Typography variant="titleMedium" component={"b"}>
        {t("quoteSplit.uploadDialog.accordionTitle")}
      </Typography>
      <AccordionGroup>
        <Accordion defaultExpanded={false}>
          <AccordionSummary>{t("quoteSplit.uploadDialog.accordionSummary")}</AccordionSummary>
          <AccordionDetails>{t("quoteSplit.uploadDialog.accordionDetails")}</AccordionDetails>
        </Accordion>
      </AccordionGroup>
    </Stack>
  );
};
